import { render, staticRenderFns } from "./MsStrategy.vue?vue&type=template&id=361b4266&scoped=true&"
import script from "./MsStrategy.vue?vue&type=script&lang=js&"
export * from "./MsStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b4266",
  null
  
)

export default component.exports